import { useState } from 'react';
import {
    ActiveButton,
    BackButton,
    BorderDiv,
    TextGrid,
    TopText,
} from '../users/style';

import back_arrow from '../../common/images/back_arrow.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { Status } from '../trade/style';
import { Loader } from '../../common/component';
import {
    useGetSingleIssuerRequestQuery,
    useUpdateIssuerRequestMutation,
} from '../../store/isssuerRequestApi';
import styled from 'styled-components';
import { ReactComponent as PdfIcon } from '../../common/images/pdf_icon.svg';
import {
    getAdminId,
    showErrorToast,
    showSuccessToast,
} from '../../common/utils';
import { Checkbox } from 'antd';
import moment from 'moment';
import { colors } from '../../common/component';
import { LoanApprovalModal } from '../../common/component/Ui/loanApproval';

export const ViewBorrowerRequest = () => {
    const param = useParams();
    const requestId = param?.id as string;
    const navigate = useNavigate();
    const adminId = getAdminId();
    const [disabled, setDisabled] = useState<boolean>(false);
    const [showLoanModal, setShowLoanModal] = useState<boolean>(false);
    const [isRejectLoading, setIsRejectLoading] = useState<boolean>(false);
    const [isApproveLoading, setIsApproveLoading] = useState<boolean>(false);

    const { data: contentData, isLoading } =
        useGetSingleIssuerRequestQuery(requestId);
    const [updateIssuerRequest] = useUpdateIssuerRequestMutation();

    console.log(contentData);

    const handleIssuerRequestStatus = (status: string) => {
        if (status === 'rejected') {
            setIsRejectLoading(true);
        } else if (status === 'approved') {
            setIsApproveLoading(true);
        }
        let payload = {
            issuerRequestId: requestId,
            requestStatus: status,
            authorizedBy: adminId,
        };

        updateIssuerRequest(payload)
            .unwrap()
            .then((result) => {
                navigate('/dashboard/borrower-request');
                showSuccessToast(result?.message);
                if (status === 'rejected') {
                    setIsRejectLoading(false);
                } else if (status === 'approved') {
                    setIsApproveLoading(false);
                }
            })
            .catch((error) => {
                showErrorToast(error?.data?.message);
            });
    };

    return (
        <div className="pb-4">
            <div className="d-flex align-items-center my-2">
                <BackButton onClick={() => navigate(-1)}>
                    <img src={back_arrow} alt="" /> Back
                </BackButton>
                <TopText>
                    {' '}
                    <span>/Become a Company</span> / View Details
                </TopText>
            </div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <BorderDiv className=" my-4 ">
                        <Col sm={8}>
                            <TextGrid>
                                <ActiveButton>Company details</ActiveButton>
                            </TextGrid>
                        </Col>
                        <Col className="d-flex align-items-center justify-content-end mb-2 mb-sm-0">
                            <Status>
                                {contentData?.data?.status === 'active' ? (
                                    <p style={{ color: '#34a853' }}>Active</p>
                                ) : (
                                    <p style={{ color: 'red' }}>InActive</p>
                                )}
                            </Status>
                        </Col>
                    </BorderDiv>

                    <Container>
                        <Header>
                            <Wrap>
                                <Text>Company Application</Text>
                                <Date>
                                    Date Submitted:{' '}
                                    {moment(
                                        contentData?.data?.createdAt,
                                    ).format('DD MM YYYY')}
                                </Date>
                            </Wrap>
                        </Header>
                        <CardOne>
                            <Title>Business Financial</Title>
                            <SubTitle>
                                Please double check the information below
                            </SubTitle>
                            <Content>
                                <Div>
                                    <Item>
                                        Business Name <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.companyName}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Revenue in The Last 1 Year{' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.revenueYearly.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Sales Growth Rate <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.salesGrowthRate}%
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Debt-To-Equity Ratio(D/E) <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.debtToEquityRatio}%
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Current Ratio <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.currentRatio}%
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Quick Ratio <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.quickRatio}%
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Total Assets <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.totalAssets.toLocaleString()}{' '}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Total Liablities <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.totalLiabilities.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Cash Flow Stability (Average Monthly
                                        Cash Flow) <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.cashFlowStability.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Account Payable Turnover (Days){' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.accountPayableTurnoverDays.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Account Receivable Turnover (Days){' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.accountReceivableTurnoverDays.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        How Much of Your Own Money Have You
                                        Invested <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.personalInvestmentAmount.toLocaleString()}
                                    </Data>
                                </Div>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.lastAuditedFinancialStatement
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.lastAuditedFinancialStatement
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={contentData?.data?.taxReturns}
                                    >
                                        <Pdf>
                                            {contentData?.data?.taxReturns}
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={contentData?.data?.bankStatements}
                                    >
                                        <Pdf>
                                            {contentData?.data?.bankStatements}
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.collateralDocument[0]
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.collateralDocument[0]
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                            </Content>
                        </CardOne>
                        <CardOne>
                            <Title>Business & Operational Factors</Title>
                            <SubTitle>
                                Please double check the information below
                            </SubTitle>
                            <Content>
                                <Div>
                                    <Item>
                                        Business Age (Number of Years in
                                        Operation) <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.businessAge} Years
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Legal & Regulatory Compliance Issues?{' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.legalAndRegulatoryComplianceIssuesExplanation
                                        }
                                    </Data>
                                </Div>

                                <Div>
                                    <Item>
                                        Management Team Experience (Years of
                                        Leadership Experience) <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.leadershipExperience
                                        }{' '}
                                        Years
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Business Model Description{' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.businessModelDescription
                                        }
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Competitive Advantage <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.competitiveAdvantage
                                        }
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Number of Active Customer <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.numberOfActiveCustomers.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Number of Active Suppliers{' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.numberOfActiveSuppliers.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Geographical & Market Risks{' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.geographicalAndMarketRisks
                                        }
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Source of Initial Capital <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.sourceOfInitialCapital
                                        }
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Initial Capital Amount <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.initialCapitalAmount.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        How Much of Your Own Money Have You
                                        Invested <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.personalInvestmentAmount.toLocaleString()}
                                    </Data>
                                </Div>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.businessRegistrationDocument
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.businessRegistrationDocument
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data?.supplierContracts
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.supplierContracts
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.proofOfPaymentToSupplier
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.proofOfPaymentToSupplier
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                            </Content>
                        </CardOne>
                        <CardOne>
                            <Title>
                                Behavioural & Alternative Data (For SMEs without
                                formal credit history)
                            </Title>
                            <SubTitle>
                                Please double check the information below
                            </SubTitle>
                            <Content>
                                <Div>
                                    <Item>
                                        Past Loan Defaults? <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.pastIssuerDefaultsExplanation
                                        }
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Explain if chosen Yes <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.legalAndRegulatoryComplianceIssuesExplanation
                                        }
                                    </Data>
                                </Div>

                                <Div>
                                    <Item>
                                        Management Team Experience (Years of
                                        Leadership Experience) <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.leadershipExperience
                                        }{' '}
                                        Years
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Delayed Payments (In the Last 2 years){' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.delayedPayments}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Trade Credit Utilization (How much
                                        supplier credit is used) <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.tradeCreditUtilization
                                        }
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Bank Overdraft Usage <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.bankOverdraftUsage}{' '}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Credit Bureau Score (If available){' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.creditBureauScore.toLocaleString()}
                                    </Data>
                                </Div>

                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.pastIssuerAgreementsAndRepaymentRecords
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.pastIssuerAgreementsAndRepaymentRecords
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.creditBureauReport
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.creditBureauReport
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.proofOfPaymentToSupplier
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.proofOfPaymentToSupplier
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                            </Content>
                        </CardOne>
                        <CardOne>
                            <Title>Business & Operational Factors</Title>
                            <SubTitle>
                                Please double check the information below
                            </SubTitle>
                            <Content>
                                <Div>
                                    <Item>
                                        Total Digital Payments Per Month{' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.totalDigitalPaymentsPerMonth.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Do you Accept Mobile or Fintech
                                        Payments? <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data
                                            ?.acceptsMobileMoneyPayments ===
                                        true
                                            ? 'Yes'
                                            : 'No'}
                                    </Data>
                                </Div>

                                <Div>
                                    <Item>
                                        Business Social Media Handles / Website
                                        (If available) <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.businessWebsite}{' '}
                                        Years
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Customer Feedback/Online <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.customerFeedback}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Supplier & Vendor Ratings <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.supplierAndVendorRating
                                        }
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Utility Bill Payment Regularity{' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {
                                            contentData?.data
                                                ?.utilityBillPaymentRegularity
                                        }
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Do you Have Crypto Investments?{' '}
                                        <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data
                                            ?.hasCryptoInvestments === true
                                            ? 'Yes'
                                            : 'No'}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Do You Engage in Gambling <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data
                                            ?.engagesInGambling === true
                                            ? 'Yes'
                                            : 'No'}
                                    </Data>
                                </Div>

                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.pastIssuerAgreementsAndRepaymentRecords
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.pastIssuerAgreementsAndRepaymentRecords
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.creditBureauReport
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.creditBureauReport
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                            </Content>
                        </CardOne>
                        {/* <CardOne>
                            <Title>License Agreement</Title>
                            <SubTitle>
                                Please agree to the following terms before
                                submitting.
                            </SubTitle>
                            <Content>
                                <Div>
                                    <ItemAgree>
                                        By checking the box to the right, you
                                        acknowledge that you have read the
                                        documents and licensing agreement,
                                        understand it, and agree to be bound by
                                        its terms and conditions.
                                    </ItemAgree>
                                </Div>
                            </Content>
                            <Checkbox
                                style={{
                                    width: '100%',
                                    color: '#7041de',
                                    borderColor: 'red',
                                }}
                                onChange={(e) => setDisabled(e.target.checked)}
                            >
                                Agree to terms and conditions
                            </Checkbox>
                        </CardOne> */}
                        <BigButtonWrap>
                            <BigButtonOne
                                onClick={() =>
                                    handleIssuerRequestStatus('rejected')
                                }
                                disabled={
                                    contentData?.data.requestStatus ===
                                    'approved'
                                        ? true
                                        : false
                                }
                            >
                                {!isRejectLoading ? 'Reject' : 'Loading...'}
                            </BigButtonOne>
                            <BigButtonTwo
                                onClick={() => setShowLoanModal(true)}
                                disabled={
                                    contentData?.data.requestStatus ===
                                    'approved'
                                        ? true
                                        : false
                                }
                            >
                                {!isApproveLoading ? 'Approve' : 'Loading...'}
                            </BigButtonTwo>
                        </BigButtonWrap>
                    </Container>
                </>
            )}
            <LoanApprovalModal
                loanItem={'Loan Request'}
                showLoanModal={showLoanModal}
                cancelLoan={() => setShowLoanModal(false)}
                handleStatus={handleIssuerRequestStatus}
            />
        </div>
    );
};

const Container = styled.div``;

const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 600px) {
        flex-direction: column;
        gap: 20px;
        align-items: flex-start;
        justify-content: flex-start;
    }
`;
const Wrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 40px;
    @media (max-width: 600px) {
        flex-direction: column;
        gap: 10px;
    }
`;
const ButtonWrap = styled.div`
    display: flex;
    gap: 10px;
`;
const Text = styled.div`
    font-weight: 500;
    @media (max-width: 600px) {
        text-align: start;
        margin-right: 13px;
    }
`;
const P = styled.p`
    color: #7041de;
    font-size: 14px;
    font-weight: 400;
`;

const Date = styled.p`
    font-size: 14px;
`;
const ButtonOne = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${colors.red};
    color: #fff;
    width: 80px;
    border: none;
    font-size: 14px;
    padding: 6px 50px;
    border-radius: 4px;
`;
const ButtonTwo = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #7041de;
    color: #fff;
    width: 80px;
    border: none;
    font-size: 14px;
    padding: 6px 50px;
    border-radius: 4px;
    text-align: center;
`;

const CardOne = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 40px;
    background: #f8f8f8;
    color: #4d4d4d;
    padding: 20px 15px;
    border-radius: 10px;
    @media (max-width: 600px) {
        margin-top: 30px;
    }
`;

const Title = styled.div`
    color: #7041de;
`;

const SubTitle = styled.div`
    background: #f8f8f;
    font-size: 13px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
`;

const Div = styled.div`
    display: flex;
    flex-direction: row;
    gap: 40px;
    font-size: 14px;
    border-bottom: 1px solid #a1a1a1;
    width: 100%;
    padding: 15px 0px;
    cursor: pointer;
`;
const Cover = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    font-size: 14px;
    border-bottom: 1px solid #a1a1a1;
    width: 100%;
    padding: 15px 0px;
    cursor: pointer;
    @media (max-width: 600px) {
        overflow: auto;
    }
`;

const Item = styled.div`
    color: #4d4d4d;
`;

const ItemAgree = styled.div`
    color: #4d4d4d;
    width: 70%;
`;

const Span = styled.span`
    color: #7041de;
`;
const Data = styled.div`
    color: #121212;
    font-size: 14px;
    font-weight: 500;
`;

const Pdf = styled.div`
    color: #7041de;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
`;
const Anchor = styled.a`
    text-underline: none;
    text-decoration: none;
`;
const BigButtonWrap = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    margin: 40px 0px 10px 0px;
`;

const BigButtonOne = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${colors.red};
    color: #fff;
    width: 80px;
    border: none;
    font-size: 14px;
    padding: 10px 50px;
    border-radius: 4px;
    width: 100%;

    &:disabled {
        background: #ccc;
        cursor: not-allowed;
    }
`;
const BigButtonTwo = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #7041de;
    color: #fff;
    width: 80px;
    border: none;
    font-size: 14px;
    padding: 10px 50px;
    border-radius: 4px;
    text-align: center;
    width: 100%;

    &:disabled {
        background: #ccc;
        cursor: not-allowed;
    }
`;
